export function useWidth(attrWidth, defaultWidth, smallMedia, alignment, containerSize) {
    containerSize = containerSize !== null && containerSize !== void 0 ? containerSize : Infinity;
    attrWidth = attrWidth === '' ? null : attrWidth;
    let width = attrWidth !== null && attrWidth !== void 0 ? attrWidth : defaultWidth;
    let maxWidth = +defaultWidth;
    width = +width;
    if (smallMedia) {
        maxWidth = 212;
    }
    if (alignment !== 'center') {
        width = Math.min(defaultWidth / 3, +(attrWidth !== null && attrWidth !== void 0 ? attrWidth : defaultWidth));
        if (defaultWidth > containerSize) {
            width = Math.min(containerSize / 3, +(attrWidth !== null && attrWidth !== void 0 ? attrWidth : defaultWidth));
        }
        maxWidth = defaultWidth / 3;
    }
    // Keep within bounds
    if (width > containerSize) {
        width = containerSize - 32;
    }
    width = parseInt(`${width}`);
    return {
        maxWidth,
        width
    };
}

//# sourceMappingURL=useWidth.js.map